module.exports = __webpack_public_path__ + "Server-Healthy.AzureSubscription.2beeb23a11a09f1ae85bb86d2d8d0b54.hashedasset.svg";